// removed by extract-text-webpack-plugin
module.exports = {"cover":"cover__3Ph7J","sub-nav":"sub-nav__2n-9O","item":"item__1-p1z","active":"active__1tJao","border":"border__2ovgB"};


//////////////////
// WEBPACK FOOTER
// ./styles/sub-navigation.scss
// module id = 1235
// module chunks = 68